import { useNavigate, useLocation } from "react-router-dom";

export const scrollToId = (id) => {
    const el = document.querySelector(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

// Navigates to hash sections (cross-page via home state) or to route paths.
export const useSmartNav = () => {
    const navigate = useNavigate();
    const location = useLocation();
    return (target) => {
        if (target.startsWith("#")) {
            if (location.pathname !== "/") {
                navigate("/", { state: { scrollTo: target } });
            } else {
                scrollToId(target);
            }
        } else {
            navigate(target);
            if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
            else window.scrollTo(0, 0);
        }
    };
};
